import { api } from "@/lib/api";

let metaPromise = null;

export function loadMeta() {
  if (!metaPromise) metaPromise = api.get("/meta/selects").then((r) => r.data);
  return metaPromise;
}

export function resetMetaCache() {
  metaPromise = null;
}
